import { render, staticRenderFns } from "./MenuRootItem.vue?vue&type=template&id=75c040b1&scoped=true&"
import script from "./MenuRootItem.vue?vue&type=script&lang=js&"
export * from "./MenuRootItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuRootItem.vue?vue&type=style&index=0&id=75c040b1&scoped=true&lang=postcss&"
import style1 from "./MenuRootItem.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c040b1",
  null
  
)

export default component.exports